import React, { FC, useEffect, useState } from 'react';
import { useBi, useTranslation } from '@wix/yoshi-flow-editor';
import { Toast, ToastPlacement, ToastSkin } from 'wix-ui-tpa/cssVars';
import { classes } from '../../Widget.st.css';
import { ActionIndicator, ActionType } from '../../../controller';

interface Props {
  actionIndicator: ActionIndicator;
}

export const ToastIndicator: FC<Props> = ({ actionIndicator }) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState('');
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    if (
      !(
        (actionIndicator.actionType === ActionType.SET_PREFERNCES ||
          actionIndicator.actionType === ActionType.FETCH_SUBSCRIBE) &&
        actionIndicator.success
      )
    ) {
      setIsShown(true);
    }
  }, [actionIndicator]);
  useEffect(() => {
    if (actionIndicator.success) {
      switch (actionIndicator.actionType) {
        case ActionType.SET_CONSENT_SUBSCRIBE:
          setErrorMessage(
            t(
              'app.widget.marketing-emails.subscription-toast.success.subscribed',
            ),
          );
          break;

        case ActionType.SET_CONSENT_UNSUBSCRIBE:
          setErrorMessage(
            t(
              'app.widget.marketing-emails.subscription-toast.success.unsubscribed',
            ),
          );
          break;
        default:
          break;
      }
    } else {
      switch (actionIndicator.actionType) {
        case ActionType.FETCH_SUBSCRIBE:
          setErrorMessage(
            actionIndicator.error ??
              t('app.widget.marketing-emails.error-toast.fetch-data'),
          );
          break;
        case ActionType.SET_CONSENT_SUBSCRIBE:
        case ActionType.SET_CONSENT_UNSUBSCRIBE:
          setErrorMessage(
            t('app.widget.marketing-emails.error-toast.set-marketing-consent'),
          );
          break;
        case ActionType.SET_PREFERNCES:
          setErrorMessage(
            t('app.widget.marketing-emails.error-toast.set-prefernces'),
          );
          break;
        default:
          break;
      }
    }
  }, [actionIndicator]);
  return (
    <Toast
      isShown={isShown}
      className={classes.subscriptionToast}
      placement={ToastPlacement.inline}
      skin={actionIndicator.success ? ToastSkin.success : ToastSkin.error}
      shouldShowCloseButton
      onClose={() => setIsShown(false)}
    >
      {errorMessage}
    </Toast>
  );
};
